var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaboolaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#0063F7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 130,
    fontFamily: "Arial, sans-serif",
    fontSize: 90,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "T")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaboolaIcon);
export default __webpack_public_path__ + "static/media/taboola_icon.6ff0612539d9a883943859d84a7fbc85.svg";
export { ForwardRef as ReactComponent };